import { useEffect } from "react";
import { Link, createFileRoute } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { RequireAuth } from "@/components/RequireAuth";
import { AppShell } from "@/components/layout/AppShell";
import { PurchaseInvoiceForm } from "@/components/purchases/PurchaseInvoiceForm";
import { useActiveCompany } from "@/lib/company-context";

export const Route = createFileRoute("/companies/$companyId/compras/new")({
  component: NewPurchaseInvoicePage,
});

function NewPurchaseInvoicePage() {
  return (
    <RequireAuth>
      <AppShell>
        <NewPurchaseInvoiceContent />
      </AppShell>
    </RequireAuth>
  );
}

function NewPurchaseInvoiceContent() {
  const { t } = useTranslation();
  const { companyId } = Route.useParams();
  const { setActiveCompanyId } = useActiveCompany();

  useEffect(() => {
    if (companyId) setActiveCompanyId(companyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  return (
    <div className="mx-auto flex max-w-6xl flex-col gap-6">
      <div>
        <Link
          to="/companies/$companyId/compras"
          params={{ companyId }}
          className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-3 w-3" />
          {t("purchases.new.back")}
        </Link>
        <h1 className="mt-1 text-2xl font-semibold tracking-tight">
          {t("purchases.new.title")}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t("purchases.new.subtitle")}
        </p>
      </div>
      <PurchaseInvoiceForm companyId={companyId} />
    </div>
  );
}
